module.exports = __webpack_public_path__ + "static/media/lana-avatar.b54c24a0.jpeg";